<template>
    <div>
        <breadcrumb :routerList="[{to:'/dingd/dingdmainlist',title:'订单管理'},{title:'创建订单'}]"/>

        <div class="h-piece ddform_disable_cls">
            <div class="h-pieceIn2">
                <div class="h-pieceTitle2" style="margin-left:10px">
                    <h1>发货信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine n-two">
                        <el-form label-position="right" :inline="true" ref="form1" :model="order"
                                 class="demo-ruleForm h-formbLine">
                            <!--<el-form-item label="是否备货" class="h-elformWrap-2">-->
                                <!--<el-select placeholder="请选择" style="width:100%" v-model="order.isStockUp" disabled="">-->
                                    <!--<el-option label="否" value="0"></el-option>-->
                                    <!--<el-option label="是" value="1"></el-option>-->
                                <!--</el-select>-->
                            <!--</el-form-item>-->
                            <!--<el-form-item label="是否走WMS" class="h-elformWrap-2" prop="isWMS">-->
                                <!--<el-select placeholder="请选择" style="width:100%" v-model="order.isWMS" disabled="">-->
                                    <!--<el-option label="否" value="0"></el-option>-->
                                    <!--<el-option label="是" value="1"></el-option>-->
                                <!--</el-select>-->
                            <!--</el-form-item>-->
                            <!--<el-form-item prop="operators" label="经营商"  class="h-elformWrap-2">-->
                                <!--<el-select v-model="order.operators" disabled="" :v="order.operators" filterable placeholder="请选择" style="width:100%">-->
                                    <!--<el-option v-for="(item,index) in QYcountryList"-->
                                               <!--:key="index" :label="`[${item.gjcode}]${item.gjname}`" :value="item.gjcode"></el-option>-->
                                <!--</el-select>-->
                            <!--</el-form-item>-->
                            <!--<el-form-item prop="warehouse" label="提货仓库" class="h-elformWrap-2" >-->
                                <!--<el-input  v-model="order.warehouse" disabled=""></el-input>-->
                            <!--</el-form-item>-->
                            <el-form-item prop="reUnit" label="收货单位" class="h-elformWrap-2">
                                <el-input  v-model="order.reUnit" disabled=""></el-input>
                            </el-form-item>
                            <el-form-item prop="contact" label="联系人" class="h-elformWrap-2" >
                                <el-input  v-model="order.contact" disabled=""></el-input>
                            </el-form-item>
                            <el-form-item prop="phone" label="联系电话" class="h-elformWrap-2" >
                                <el-input  v-model="order.phone" disabled=""></el-input>
                            </el-form-item>
                            <el-form-item prop="address" label="客户地址" class="h-elformWrap-2">
                                <el-input  v-model="order.address" disabled=""></el-input>
                            </el-form-item>
                            <el-form-item prop="totalVolume" label="立方数" class="h-elformWrap-2">
                                <el-input disabled="" v-model="order.totalVolume"></el-input>
                            </el-form-item>
                            <el-form-item label="要求送货时间" class="h-elformWrap-2" prop="requiredDeliveryTime">
                                <el-date-picker v-model="order.requiredDeliveryTime" type="datetime" :clearable="false"
                                                class="h-tableInput"
                                                disabled=""
                                                value-format="yyyy-MM-dd HH:mm" :placeholder="order.requiredDeliveryTime"
                                                placeholder="请选择日期" :picker-options="pickerOptions">
                                </el-date-picker>
                            </el-form-item>
                            <!--<el-form-item prop="address" label="运输路线" class="h-elformWrap-2">-->
                                <!--<el-input  v-model="order.transportLine" disabled=""></el-input>-->
                            <!--</el-form-item>-->
                            <!--<el-form-item prop="address" label="物流商" class="h-elformWrap-2">-->
                                <!--<el-input  v-model="order.logisticsProvider" disabled=""></el-input>-->
                            <!--</el-form-item>-->
                        </el-form>
                    </div>
                </div>
            </div>
            <!-------------------------------------------------------订单信息-------------------------------------------------------------------->

        <!-------------------------------------------------------产品信息-------------------------------------------------------------------->
        <div class="h-table h-mrt30 ljjtablepaddings3" style="margin: -10px 20px 0 20px;">
            <div class="h-pieceTitle2 message">
                <h1 class="h1">发货计划信息</h1>
                    <!--<el-button size="small" type="primary"-->
                               <!--icon="el-icon-circle-plus"-->
                               <!--style="margin-left: 50px;"-->
                               <!--@click="showProcuct1" v-if="showaddProductRow">选择发货计划-->
                    <!--</el-button>-->
                <!--<span style="color: red;font-size: 12px;display: inline-block;padding-left: 20px;">计算逻辑已经修改，请直接填写成交价</span>-->
            </div>
            <el-table
                    ref="multipleTable"
                    :data="productlist1"
                    stripe
					border
                    style="width: 100%">
                <el-table-column
                        type="index"
                        fixed
                        label="#"
                        width="40">
                </el-table-column>
                <el-table-column
                        prop="shipmentCode"
                        label="发计划编码"
                        width="150" >
                </el-table-column>
                <el-table-column
                        prop="add3"
                        label="DN单号"
                        width="150" >
                </el-table-column>
                <el-table-column
                        prop="requiredDeliveryTime"
                        label="要求送货时间"
                        :show-overflow-tooltip="true"
                        width="110">
                </el-table-column>
                <el-table-column
                        prop="sapCode"
                        label="订单号"
                        :show-overflow-tooltip="true"
                        width="180">
                </el-table-column>
                <el-table-column
                        prop="cdate"
                        label="下单日期"
                        :show-overflow-tooltip="true"
                        width="100">
                </el-table-column>
                <!--<el-table-column-->
                        <!--prop="waybillCount"-->
                        <!--label="运单数量"-->
                        <!--:show-overflow-tooltip="true"-->
                        <!--width="100">-->
                    <!--<template slot-scope="scope">-->
                        <!--<el-input v-model="scope.row.waybillCount"-->
                                  <!--placeholder="请输入" disabled="k"-->
                                  <!--@keyup.native='keyupEvent($event ,input)'-->
                                  <!--class="DshuR h-tableInput" auto-complete="off"></el-input>-->
                    <!--</template>-->
                <!--</el-table-column>-->
                <el-table-column
                        prop="materialCode"
                        label="物料编码"
                        :show-overflow-tooltip="true"
                        width="110">
                </el-table-column>
                <el-table-column
                        prop="materialName"
                        label="物料名称"
                        :show-overflow-tooltip="true"
                        min-width="180">
                </el-table-column>
                <!--<el-table-column-->
                        <!--prop="wltiji"-->
                        <!--label="单位体积"-->
                        <!--width="120"-->
                        <!--:show-overflow-tooltip="true">-->
                <!--</el-table-column>-->
                <el-table-column
                        prop="proNumber"
                        label="物料数量"
                        :show-overflow-tooltip="true"
                        width="110">
                </el-table-column>
                <!--<el-table-column label="操作" width="80" fixed="right">-->
                    <!--<template slot-scope="scope">-->
                       <!--<el-button-->
                                <!--type="text"-->
                                <!--size="small"-->
                                <!--class="h-tableLink h-btn"-->
                                <!--@click="deleteThis(scope.row)">-->
                            <!--删除-->
                        <!--</el-button>-->
                    <!--</template>-->
                <!--</el-table-column>-->
            </el-table>
        </div>
        <!-------------------------------------------------------产品信息-------------------------------------------------------------------->


        <!--------------------------------------------------------------------收货地址弹出框-------------------------------------------------------->
        <!--物料-->
        <!--<waixiaowxwl :visible.sync="showwuliaodialog1"
                     v-if="showwuliaodialog1"
                     @choseObj="choseWuliao1"
              title="选择预测单"/>-->
    </div>
	<div>
	    <div class="anniu">
			<el-button class="h-btn h-bBtn h-bgwhite"  @click="backtolist">返回</el-button>
			<!--<el-button class="h-btn h-bBtn h-bggreen" @click="saveOrSubmit(10)">暂存</el-button>-->
			<!--<el-button class="h-btn h-bBtn h-bgblueQ2" @click="saveOrSubmit(20)">确认提交</el-button>-->
	    </div>
	</div>
</div>
</template>

<script>
    import big from 'big.js'
    import ss from '../../api/SystemService'
   // import waixiaowxwl from '../../components/dialog/wxwl-delivery'
    import shoudf from '../../components/dialog/selectshdf'

    export default {
        components: {
             shoudf
        },
        data() {
            return {
                id:null,
                submitChongfuFlag:true,
                //有国家大区的国家
                QYcountryList:[],
                areaList:[],
                areaUserList:[],
				costList:[],

				showIsFree:false,

                resubmit:false,
                instid:null,
                taskstatus:0,

                showhistory:false,

                selectDailishang:true,


                showwuliaodialog1:false,
                showwuliaodialog2:false,
                showshdfdialog:false,
                showdizhiflag:false,
                currentUser:null,
                showaddProductRow:true,
                showFee:true,

                //showdelProductRow: true,

                //是否需要信贷
                needxindai:true,
                needxinjin:true,
                //付款方式，不需要信贷
                fjksnotjy:['HT02','LC50'],
                //上传信用证
                shifouxinyzh:false,
                //特价
                tejieshowflag:false,
                //定制展示
                dingzhishowflag:false,

                //单位
                dwzhiliang:null,
                dwtiji:null,
                //现金余额
                cashBalance:0,
                //项目编码
                xmcode:null,
                ddlx:null,
                // 限制收货时间不让选择今天以前的
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
                    }
                },
                order:{
                    shipmentCode:null,
                    transportLine:null,
                    logisticsProvider:null,
                    isStockUp:null,
                    isWMS:null,
                    id:null,
                    operators:null,
                    warehouse:null,
                    contact:null,
                    phone:null,
                    reUnit:null,
                    address:null,
                    totalVolume:null,
                    orderMainProducts:[],
                },

                //产品list
                productlist1:[],

                //用户信贷list
                creditData:[],
                disabled:false,
            }
        },
        //页面加载前事件
        created() {
            this.id = this.$route.query.id;
            this.showQycountry();
            // this.createShipmentNum();
        },
        mounted(){

        },
        computed:{

        },
        watch:{
        },
        methods: {
            keyupEvent(e,input){
                e.target.value=e.target.value.replace(/[^\d.]/g, '');
                e.target.value=e.target.value.replace(/\.{2,}/g, '.');
                e.target.value=e.target.value.replace(/^\./g, '0.');
                e.target.value=e.target.value.replace(/^\d*\.\d*\./g, e.target.value.substring(0,e.target.value.length-1));
                e.target.value=e.target.value.replace(/^0[^\.]+/g, '0')
                e.target.value=e.target.value.replace(/^(\d+)\.(\d\d).*$/, '$1.$2')
                this.input=e.target.value
            },
            viewpress(r){
                this.showhistory = true;
            },
            backtolist(){
              this.$router.go(-1);
            },
            saveOrSubmit(v){
                this.order.shipmentCode = this.productlist1.join(',');
                let id = [];
                this.productlist1.forEach((item)=>{
                    id.push(item.shipmentCode);
                })
                this.order.shipmentCode = id.join(",")
                    this.$refs['form1'].validate((valid1) => {
                        if (valid1) {
                            this.$msg.confirm("确认提交？",()=>{
                                this.submitForm();
                            })
                        }else{
                            this.$msg.msge("请完善基本信息后提交");
							return;
                        }
                    });
            },
            submitForm(){
                    this.submitChongfuFlag = false;
                    for(var i=0;i<this.productlist1.length;i++){
                        this.productlist1[i].deliveryTime=null;
                        this.productlist1[i].createTime=null;
                    }
                    this.order.orderMainProducts = this.productlist1
                    ss.OrderMainService.addCarApplication(this.order).then(rd=>{
                        this.submitChongfuFlag = true;
                        if(rd.f) {
                            this.$msg.msgs("提交成功！")
                            this.$router.push({path: '/dingd/deliveryCarList'})
                        }else{
                            this.$msg.msge(rd.msg);
                        }
                    })
            },
            //删除该行项目产品信息f
            deleteThis(x) {
                this.$msg.confirm("确认删除？",()=>{
                    this.productlist1 = _.reject(this.productlist1, {'shipmentCode': x.shipmentCode});
                })
            },
            //选择物料
            showProcuct1() {
                this.showwuliaodialog1 = true;
            },
            querypage(p){
                var data = {};
                data.id = this.order.shipmentCode;
                ss.OrderMainService.selectCarList(data).then(rd => {
                    this.productlist1 = rd;
                    //console.log('tableData', this.tableData);
                    // this.formInline.total = rd.total || 0;
                });
            },
            //选择物料
            choseWuliao1(objs) {
                this.productlist1 = [];
                objs.forEach((item,index) => {
                    this.productlist1.push(item);
                });
                this.showwuliaodialog1 = false;
            },
            //有国家大区的送达方
            showQycountry(){
                ss.OrderMainService.showQycountry().then(rd=>{
                    this.QYcountryList = rd;
                    this.query();

                })
            },
            query(){
                ss.OrderMainService.carQycountry(this.id).then(rd=>{
                    this.order = rd;
                    this.querypage();
                })
            },
            //发货单号
            // createShipmentNum(){
            //     console.log(123)
            //     ss.OrderMainService.createShipmentNum().then(rd=>{
            //         this.order.id = rd;
            //     })
            // },
        }
    }

</script>


<style scoped>
    .queren {
        background-color: #006aca;
        color: white;
    }

    .anniu {
        display: flex;
		justify-content: center;
		align-items: center;
    }

    .zancun {
        background-color: #24b5b8;
        color: white;
    }

    .quxiao, .zancun {

        width: 100px;
    }
    .jieguo {
        border-bottom: 1px solid rgb(238, 236, 236);
        display: flex;
    }
    .jieguo .jieguo_label{
        width: 2rem;
        text-align: right;
        background-color: #ebf5ff;
        font-size: 0.16rem;
        color: #616467;
        height: 0.4rem;
        line-height: 0.4rem;
        padding: 0 0.05rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .jieguo .jieguo_value{
        width: 20%;
        font-size: 0.16rem;
        color: #616467;
        height: 0.4rem;
        line-height: 0.4rem;
        padding: 0px 8px;
    }
    img {
        width: 25px;
        padding: 5px 0;
        margin-left: 8rem;
    }

    .newProject {
        margin: 0 20px;
        background-color: rgb(94, 182, 233);
    }
    .h-piece {
        margin: 20px;
    }
    .DshuR {
        width: 100%;
        height: 100%;
        border: none;
    }


    .message {
        padding: 20px 0;
        margin-bottom: 0;
        background-color: white;
    }

    .n-xiao .h-formbLine .h-elformWrap-2,
    .n-two .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
    }

    .el-cascader {
        line-height: normal;
    }
</style>
<style>
    .n-two .h-formbLine .el-form-item__content .el-select,
    .n-two .el-form .h-formbLine .el-form-item__content .el-select {
        width: 0;
    }

    .n-xiao .h-formbLine .el-form-item__label,
    .n-two .h-formbLine .el-form-item__label {
        width: 43%;
    }

    .n-xiao .h-formbLine .el-form-item__content,
    .n-two .h-formbLine .el-form-item__content {
        width: 57%;
    }


    /* .el-table__header .el-table-column--selection .cell .el-checkbox::after {
        content: "全选";
        color: white;
        background-color: rgb(93, 172, 236);
        font-size: 10px;
    } */
	.ljjtablepaddings3 .h-tableInput .el-input__inner{
		padding: 0.05rem 0.1rem;
	}
	.ljjtablepaddings3 .h-tableInput .el-input__icon{
		line-height: 0.25rem;
	}
	.ljjtablepaddings3 .ljjsales .el-input__inner{
		height: 0.3rem;
	}
	.ljjtablepaddings3 .ljjsales .el-input__icon{
		line-height: 0.42rem;
	}
</style>

<style scoped lang="scss">
    .areaSelect {
        position: fixed;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.6);
        top: 0;
        left: 0;
        z-index: 2019;

        .centerBlock {
            width: 700px;
            height: 400px;
            padding: 20px;
            border-radius: 20px;
            background-color: white;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
    .dingzhicss{
        font-size: 12px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
</style>
<style>
    .aaa .el-dialog__headerbtn {
        display: none;
    }
    .ddform_disable_cls .el-form-item__content .el-input__inner[disabled] {
        color: #868686;
    }
</style>
